import { useEffect, useRef, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from '@/components/Text';
import colors from '@/config/colors';

const styles = StyleSheet.create({
  visible: { color: colors.black },
  hidden: { color: 'transparent' },
  backgroundWhite: { backgroundColor: 'white' },
  backgroundGreen: { backgroundColor: colors.primaryBrighter },
  fontGreen: { color: colors.primary },
});

const HiddenText = ({
  visible,
  greenBackground = true,
  timeout = 500,
  style = [],
  text,
  isColored,
}) => {
  const [currentStyle, setCurrentStyle] = useState([
    visible ? styles.visible : styles.hidden,
    styles.backgroundWhite,
    ...style,
  ]);

  const refText = useRef(null);

  useEffect(() => {
    let timerHandle;
    if (visible) {
      if (greenBackground) {
        setCurrentStyle([
          styles.visible,
          isColored && styles.backgroundGreen,
          ...style,
        ]);
      } else {
        setCurrentStyle([isColored && styles.fontGreen, ...style]);
      }

      timerHandle = setTimeout(() => {
        setCurrentStyle([styles.visible, styles.backgroundWhite, ...style]);
      }, timeout);
    }

    return () => {
      if (timerHandle) {
        clearTimeout(timerHandle);
      }
    };
  }, [visible, greenBackground, timeout, style, isColored]);

  return (
    <Text
      selectionColor={'white'}
      style={[currentStyle, { userSelect: 'none' }]}
      ref={refText}
    >
      {text}
    </Text>
  );
};

export default HiddenText;
